import React, { useEffect } from 'react';
import { AlertTriangleIcon, XIcon } from 'lucide-react';
import { Button } from './Button';
interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  description: string;
  confirmText?: string;
  cancelText?: string;
  isDestructive?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}
export function ConfirmDialog({
  isOpen,
  title,
  description,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  isDestructive = false,
  onConfirm,
  onCancel
}: ConfirmDialogProps) {
  // Escape key to close
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onCancel();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onCancel]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 animate-fade-in" onClick={onCancel} role="dialog" aria-modal="true" aria-labelledby="confirm-dialog-title" data-id="element-1045">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md overflow-hidden animate-slide-up" onClick={e => e.stopPropagation()} data-id="element-1046">
        <div className="flex items-start justify-between p-6 border-b border-border" data-id="element-1047">
          <div className="flex items-center gap-3" data-id="element-1048">
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${isDestructive ? 'bg-urgent/10' : 'bg-primary/5'}`} data-id="element-1049">
              <AlertTriangleIcon className={`w-5 h-5 ${isDestructive ? 'text-urgent' : 'text-primary'}`} data-id="element-1050" />
            </div>
            <h2 id="confirm-dialog-title" className="text-lg font-bold text-text-primary" data-id="element-1051">
              {title}
            </h2>
          </div>
          <button onClick={onCancel} className="text-text-tertiary hover:text-text-primary transition-colors rounded-md p-1" aria-label="Close dialog" data-id="element-1052">
            <XIcon className="w-5 h-5" data-id="element-1053" />
          </button>
        </div>

        <div className="p-6" data-id="element-1054">
          <p className="text-sm text-text-secondary leading-relaxed" data-id="element-1055">
            {description}
          </p>
        </div>

        <div className="flex items-center justify-end gap-3 px-6 py-4 bg-surface-warm border-t border-border" data-id="element-1056">
          <Button variant="secondary" onClick={onCancel} data-id="element-1057">
            {cancelText}
          </Button>
          <Button variant="primary" onClick={onConfirm} className={isDestructive ? 'bg-urgent hover:bg-urgent/90' : ''} data-id="element-1058">
            {confirmText}
          </Button>
        </div>
      </div>
    </div>;
}